// extracted by mini-css-extract-plugin
export default {"toolbar":"SlateToolbar_toolbar__Ap2Sn","stickyToolbar":"SlateToolbar_stickyToolbar__4JeZu"};